// extracted by mini-css-extract-plugin
export var container = "RemoveDog-module--container--f32e2";
export var iconWrapper = "RemoveDog-module--iconWrapper--b1b3d";